export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-mail-line',
      label: 'Email',
      value: 'support@doonova-grosisnis.com'
    },
    {
      icon: 'ri-phone-line',
      label: 'Phone',
      value: '+1 2312102800'
    },
    {
      icon: 'ri-map-pin-line',
      label: 'Address',
      value: 'Nosioci Karadjordjeve Zvezde 21\nNis, 701129\nSerbia'
    }
  ];

  return (
    <section id="contact" className="py-36 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-24">
          <h2 className="text-6xl font-bold text-gray-900 mb-6">Get in Touch</h2>
          <p className="text-xl text-gray-600">We're here to help</p>
        </div>

        <div className="grid grid-cols-3 gap-16">
          {contactInfo.map((info, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <i className={`${info.icon} text-cyan-500 text-5xl`}></i>
              </div>
              <div className="text-sm uppercase text-gray-500 tracking-wider mb-4">
                {info.label}
              </div>
              <div className="text-xl font-bold text-gray-900 whitespace-pre-line">
                {info.value}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}